/*
 * @Author: EdwardYoung
 * @Date: 2017-08-29 14:32:43
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-17 00:47:15
 */

/**
 *
 * @param {Date} startTime 活动开始时间
 * function 判断活动是否过期
 */
function isActivityBegin (startTime) {
  let startDate = new Date(startTime).getTime()
  let currentDate = new Date().getTime()
  if (startDate <= currentDate) {
    return true
  } else {
    return false
  }
}

export {isActivityBegin}




// WEBPACK FOOTER //
// ./src/common/util/isActivityBegin.js